export default "__VITE_ASSET__8e68a0bc__"